import { v4 as uuidv4 } from 'uuid';
import { normalizeOrganisation } from './fuehrungsDiagramm';

// Szenarien werden ohne Login lokal im Browser gespeichert (localStorage).
// Zum Weitergeben dient der JSON-Export/-Import.

const STORAGE_KEY = 'planspiel.scenarios.v1';

const readAll = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

// Wirft bei vollem Speicher (QuotaExceededError) oder gesperrtem localStorage
const writeAll = (scenarios) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(scenarios));
};

export const listScenarios = () =>
  readAll().sort((a, b) => String(b.updated_at).localeCompare(String(a.updated_at)));

// Legt ein neues Szenario an oder aktualisiert das mit gleicher id
export const saveScenario = ({ id, name, description, center, zoom, elements, organisation }) => {
  const now = new Date().toISOString();
  const scenarios = readAll();
  const existing = id ? scenarios.find(s => s.id === id) : null;
  const scenario = {
    id: existing?.id || uuidv4(),
    name,
    description: description || '',
    center,
    zoom,
    elements: elements || [],
    organisation: normalizeOrganisation(organisation),
    created_at: existing?.created_at || now,
    updated_at: now,
  };
  writeAll([scenario, ...scenarios.filter(s => s.id !== scenario.id)]);
  return scenario;
};

export const deleteScenario = (id) => {
  writeAll(readAll().filter(s => s.id !== id));
};

const isPoint = (p) => p && Number.isFinite(p.lat) && Number.isFinite(p.lng);

// Prüft eine importierte JSON-Datei (Format von "Exportieren") und liefert ein Szenario
export const parseScenarioFile = (text) => {
  const data = JSON.parse(text);
  if (!data || typeof data !== 'object' || !Array.isArray(data.elements) || !isPoint(data.center)) {
    throw new Error('Keine gültige Planspiel-Datei');
  }
  const elements = data.elements.filter(el =>
    el && typeof el.id === 'string' && typeof el.type === 'string' &&
    (isPoint(el.position) || (Array.isArray(el.positions) && el.positions.every(isPoint)))
  );
  return {
    name: typeof data.name === 'string' && data.name.trim() ? data.name.trim().substring(0, 200) : 'Importiertes Szenario',
    description: typeof data.description === 'string' ? data.description.substring(0, 2000) : '',
    center: { lat: data.center.lat, lng: data.center.lng },
    zoom: Number.isFinite(data.zoom) ? data.zoom : 15,
    elements,
    organisation: normalizeOrganisation(data.organisation),
  };
};
